import { useState } from "react"
import Kpi from "../../../../components/responsive/kpi"
import SeverityBadge from "../../../../components/responsive/severity-badge"
import InfoRow from "../../../../components/responsive/info-row"
// ! 중복 제거할것
const FILTER_LABELS = {
  leak_volume: { ko: "누수량", en: "Leak Volume" },
  usage_volume: { ko: "사용량", en: "Usage" },
  leak_rate: { ko: "누수율", en: "Leak Rate" },
  leak_type: { ko: "누수유형", en: "Leak Type" },
  leak_severity: { ko: "누수 심각도", en: "Leak Severity" },
  business_type: { ko: "업종명", en: "Business Type" },
  caliber: { ko: "구경 (mm)", en: "Diameter (mm)" }
}

const orgTableBundle = {
  filterLabels: FILTER_LABELS,
  mobileCardBundle: {
    toggle: {
      expand: { ko: "펼치기", en: "Expand" },
      collapse: { ko: "접기", en: "Collapse" }
    },
    labels: {
      sector: { ko: "업종", en: "Business Type" },
      diameter: { ko: "구경(mm)", en: "Diameter (mm)" },
      address: { ko: "주소", en: "Address" },
      leak_hours: { ko: "누수기간", en: "Leak Duration" }
    }
  }
}

const GridCard = ({ hit, lang, onOpen }) => {
  const [open, setOpen] = useState(false)

  return (
    <div className="p-4 bg-white rounded-xl border border-gray-200 shadow-sm">
      {/* 상단: 고객명 + 심각도 */}
      <div className="flex items-start gap-2">
        <div className="min-w-0">
          <div className="font-semibold text-gray-900 truncate">{hit.customer_name ?? "-"}</div>

          <button className="mt-1 text-sm text-blue-700 hover:underline" onClick={onOpen}>
            {hit.customer_id}
          </button>
        </div>

        <div className="ml-auto">
          <SeverityBadge text={hit.leak_severity?.[lang] ?? "-"} />
        </div>
      </div>

      {/* 요약 KPI (다국어 적용) */}
      <div className="mt-3 grid grid-cols-2 gap-2 text-sm">
        <Kpi
          label={orgTableBundle.filterLabels.leak_rate[lang]}
          value={hit.leak_rate ?? "-"}
          suffix="%"
        />
        <Kpi
          label={orgTableBundle.filterLabels.leak_volume[lang]}
          value={hit.leak_volume ?? "-"}
          suffix="m³"
        />
        <Kpi label={orgTableBundle.filterLabels.leak_type[lang]} value={hit.leak_type ?? "-"} />
        <Kpi
          label={orgTableBundle.filterLabels.usage_volume[lang]}
          value={hit.usage_volume ?? "-"}
          suffix="m³"
        />
      </div>

      {/* 더보기/접기 버튼 (다국어 적용) */}
      <div className="mt-3">
        <button
          className="text-sm text-gray-600 hover:text-gray-900"
          onClick={() => setOpen((v) => !v)}
        >
          {open
            ? orgTableBundle.mobileCardBundle.toggle.collapse[lang]
            : orgTableBundle.mobileCardBundle.toggle.expand[lang]}
        </button>

        {open && (
          <div className="mt-3 pt-3 border-t text-sm text-gray-700 space-y-1">
            <InfoRow
              label={orgTableBundle.mobileCardBundle.labels.sector[lang]}
              value={hit.business_type ?? "-"}
            />
            <InfoRow
              label={orgTableBundle.mobileCardBundle.labels.diameter[lang]}
              value={hit.caliber ?? "-"}
            />
            <InfoRow
              label={orgTableBundle.mobileCardBundle.labels.address[lang]}
              value={`${hit.address ?? "-"}`}
            />
            <InfoRow
              label={orgTableBundle.mobileCardBundle.labels.leak_hours[lang]}
              value={hit.leak_hours ?? "-"}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default GridCard
